import {
	Popover,
	PopoverMenu,
	PopoverMenuItem,
} from '@audio-network/componentlibrary'

import { LanguageSelectorProps } from './LanguageSelector.types'
import clsx from 'clsx'
import { languages } from './LanguageSelector.constants'
import { sendAnalytics } from '@audio-network/analytics'
import styles from './LanguageSelector.module.css'
import { useTranslation } from 'next-i18next'

const LanguageSelector = ({
	className,
	id,
}: LanguageSelectorProps): JSX.Element => {
	const { t } = useTranslation(['navigation'])

	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<Popover
			className={clsx(className, styles.languagePopover)}
			id={id}
			mobileCloseLabel={t('close')}
		>
			<PopoverMenu className={styles.languageList}>
				{languages.map((language) => (
					<PopoverMenuItem
						key={language.locale}
						content={
							<a
								aria-label={language.ariaLabel}
								href={language.href}
								className={styles.languageItem}
								onClick={() => handleClick(language.region)}
							>
								{language.language}
								<span className={styles.region}>{language.region}</span>
							</a>
						}
						onClick={() => handleClick(language.region)}
					/>
				))}
			</PopoverMenu>
		</Popover>
	)
}

export default LanguageSelector
